<!--
@component
Row of checkbox-style category buttons (secondary `MarketingButton`s) that
show a checkmark on the selected category. Dark theme by default.
-->

<script lang="ts">
  import CheckIcon from "@lucide/svelte/icons/check";
  import clsx from "clsx";

  import MarketingButton, {
    type Props as MarketingButtonProps,
  } from "$lib/design-systems/marketing/primitives/legacy-v1/MarketingButton.svelte";

  interface Props {
    categories: string[];
    updateCategory: (category: string) => void;
    selectedCategory?: string | null;
    theme?: MarketingButtonProps["theme"];
  }

  let {
    categories,
    updateCategory,
    selectedCategory = null,
    theme = "dark",
  }: Props = $props();

  function handleCategoryUpdate(category: string) {
    updateCategory(category);
  }
</script>

<div class="flex flex-wrap gap-3">
  {#each categories as category}
    <MarketingButton
      variant="secondary"
      {theme}
      onclick={() => handleCategoryUpdate(category)}
    >
      <div class="flex flex-row items-center gap-2">
        {#if selectedCategory === category}
          <div
            class={clsx(
              "flex h-6 w-6 items-center justify-center rounded-full border",
              theme === "light"
                ? "border-c-pale-green-15 bg-c-pale-green-15"
                : "border-c-green-100 bg-c-green-100 ",
            )}
          >
            <CheckIcon
              size={18}
              class={clsx(theme === "light" ? "text-white" : "text-black")}
            />
          </div>
        {:else}
          <div
            class={clsx(
              "h-6 w-6 rounded-full border",
              theme === "light"
                ? "border-c-pale-green-15 bg-c-green-40/10"
                : "border-light-green/30 bg-light-green/10 ",
            )}
          ></div>
        {/if}
        {category}
      </div>
    </MarketingButton>
  {/each}
</div>
